import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useDrawer, RowTrigger } from '@grandvisionhq/common';

const ProductDetailSpecificationDrawerCTA = ({ title  })=>{
    const { toggle  } = useDrawer();
    const handleClick = ()=>{
        DataLayer.Events.pushDrawerEventToDataLayer({
            siteFeature: 'specifications',
            interactionType: 'specifications_click'
        });
        toggle();
    };
    return /*#__PURE__*/ React.createElement(RowTrigger, {
        title: title,
        onClick: handleClick,
        "data-t": "specification-drawer-trigger"
    });
};

export { ProductDetailSpecificationDrawerCTA };
//# sourceMappingURL=ProductDetailSpecificationDrawerCTA.js.map
